import React from 'react'

import { TradingPoolCampaignClientResult } from '@pages/Traders-Room/Campaign-Results/Trading-Pools/TradingPoolCampaignClientResult'
import { TradingPoolCampaignClientResultMobile } from '@pages/Traders-Room/Campaign-Results/Trading-Pools/TradingPoolCampaignClientResultMobile'
import { TradingPoolCampaignLeaderboard } from '@pages/Traders-Room/Campaign-Results/Trading-Pools/TradingPoolCampaignLeaderboard'

import { useWindowResize } from '@utils/domUtils'

import { Box } from '@shared/components/Box'

export const TradingPoolResultsPage: React.FC = () => {
  const isMobile = useWindowResize()
  return (
    <Box flex direction={'column'} gap={'x32'}>
      {isMobile ? <TradingPoolCampaignClientResultMobile /> : <TradingPoolCampaignClientResult />}
      <TradingPoolCampaignLeaderboard />
    </Box>
  )
}
